import React, { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';
import {
  useRecoilState,
  useRecoilValue,
} from 'recoil';
import {
  isAdmin,
  subMenuState,
} from 'state';
import styled from 'styled-components';
import InProgress from 'view/pages/Classes/components/subPage/InProgress';
import Published from 'view/pages/Classes/components/subPage/Published';
import SubClasses from 'view/pages/Classes/components/subPage/SubClasses';

import BannerImg from '../../../assets/images/banner.png';
import PlutIcon from '../../../assets/images/plus.png';
import {
  Banner,
  ContentBox,
  Contents,
  Icon,
} from '../../components';
import {isEmpty} from "../../../util";

interface StyledComponentProps {
    width?: string;
    display?: string;
}

const Classes = () => {
    const navigate = useNavigate()
    const isAdminState = useRecoilValue(isAdmin);
    const [subMenu, setSubMenu] = useRecoilState(subMenuState);
    const el = () => {
        switch (subMenu) {
            case "classes": {
                return <SubClasses />;
            }
            case "In Progress": {
                return <InProgress />;
            }
            case "Published": {
                return <Published />;
            }
            default:
                break;
        }
    };

    useEffect(() => {
        if (isAdminState) {
            setSubMenu("In Progress");

        } else {

                setSubMenu("classes");
        };
    }, [isAdminState]);

    return (
        <Container>
            <ContentsWrap>
                <Wrap>
                    <ContentBox>
                        <Banner url={"/images/banner.png"} img={BannerImg} width={"100%"} height={220}>
                            <BannerContents>
                                <div className="textarea">
                                    <h2>check your published classes?</h2>
                                    <p>
                                        Lorem ipsum dolor sit amet consectetur. Pellentesque porttitor
                                        in pellentesque pellentesque nec consequat mon.
                                    </p>
                                </div>

                                {!isAdminState && (
                                    <Create onClick={() => {
                                        navigate("/create/details", {
                                            state: {
                                                createId:null
                                            }
                                        })
                                    }}>
                                        <CreateContents>
                                            <Icon icon={PlutIcon} />
                                            <span>Create Class</span>
                                        </CreateContents>
                                    </Create>
                                )}
                            </BannerContents>
                        </Banner>
                        <Contents title={subMenu}>{el()}</Contents>
                    </ContentBox>
                </Wrap>
            </ContentsWrap>
        </Container>
    );
};
export default Classes;

const Container = styled.div`

`;
const ContentsWrap = styled.div`
    display: flex;
    width: 100%;

`;
const Wrap = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: hidden;
    flex: 1;
    .banner{
        height: 220px;
    }
`;

const BannerContents = styled.div`
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    z-index: 1;
    padding: 25px 20px;
    height: 220px;
    background: linear-gradient(269.04deg, rgba(0, 0, 0, 0) 39%, rgba(0, 0, 0, 0.75) 79.51%);
    h2 {
        text-transform: uppercase;
        color: #fff;
        font-size: 28px;
        font-weight: 600;
        margin-bottom: 10px;
        opacity: 0.9;
        line-height: 35.28px;
        width: 100%;
        font-family: "Source Serif 4", sans-serif;;
        @media screen and (max-width: 800px) {
            line-height: 1.2em;
            font-size: 1.3em;
        }
    }
    p {
        opacity: 0.8;
        color: #fff;
        width: 470px;
        line-height: 24px;
        font-size: 18px;
        margin-bottom: 30px;
        font-weight: 400;
        @media screen and (max-width: 406px) {
            line-height: 1.1em;
            font-size: 1em;
        }
        @media screen and (max-width: 800px) {
            //font-size: 2.5vw;
            //font-size: 50%;
     
            margin-bottom: 10px;
            width: 100%;
        }
    }
`;

const Create = styled.div`
    background: #ddc160;
    font-size: 14px;
    border-radius: 6px;
    display: inline-block;
    align-items: center;
    justify-content: center;
    padding: 10px 0px;
    cursor: pointer;
    width: 160px;
    transition: all 0.2s;
    &:hover{
        transform: scale(1.05);
    }
    img {
        width: 16px;
        height: 16px;
    }
`;
const CreateContents = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    width: 160px;
    span {
        line-height: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
        margin-left: 10px;
    }
`;
